export default "__VITE_ASSET__05e1dc1b__"